export class IndirizzoDiStudio {
  id;
  codice;
  denominazione;
}
